import React, { useEffect } from 'react';
import { MonitoringContent } from 'components/SeoMonitoring';
import TableHeaderDateControls from 'components/TableHeaderDateControls';
import { useFilterReducer } from 'context/filter/filter.context.reducer';

const Monitoring = () => {
  const { resetFilter } = useFilterReducer();
  const searchParams = new URLSearchParams(document.location.search);
  const filter = searchParams.get('filter');
  useEffect(() => {
    if (!filter) {
      resetFilter();
    }
  }, [filter, resetFilter]);
  return (
    <div className="pt-4">
      <div className="px-8 flex justify-between">
        <div>
          <h1>Мониторинг поисковых запросов</h1>
          <div className="text-gray-400 mt-1 mb-4">
            <span className="block">
              Инструмент помогает отслеживать позиции вашего товара по группе поисковых фраз.
            </span>
            <span className="block">
              С помощью него удобно наблюдать за результатами SEO оптимизации
            </span>
          </div>
        </div>
        <div>
          <TableHeaderDateControls usePeriods={false} />
        </div>
      </div>
      <MonitoringContent />
    </div>
  );
};

export default Monitoring;
